import React from 'react';
import { Editor } from './Editor.js';
import { highlight as prismHighlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-sql';
import 'prismjs/themes/prism-tomorrow.css';
import { useTranslation } from '../../i18n/useTranslation.js';

interface SqlEditorProps {
  sqlQuery: string;
  readOnly?: boolean;
  onChange?: (value: string) => void;
  hint?: string;
}

function SqlEditor({ sqlQuery, readOnly = true, onChange, hint }: SqlEditorProps) {
  const { t } = useTranslation();

  const highlight = (code: string) => prismHighlight(code || '', languages.sql);

  return (
    <div style={{ marginTop: 6 }}>
      <Editor
        value={sqlQuery ?? ''}
        onValueChange={onChange ?? (() => {})}
        highlight={highlight}
        readOnly={readOnly}
        padding={10}
        style={{
          fontFamily: 'var(--mono, monospace)',
          fontSize: 12,
          background: 'var(--bg-deep, #0e1117)',
          border: '1px solid var(--bs, rgba(255,255,255,0.06))',
          borderRadius: 4,
          color: 'var(--t1, #eef2ff)',
          minHeight: 60,
          maxHeight: 400,
          overflow: 'auto',
        }}
      />
      {hint && (
        <p
          style={{
            marginTop: 4,
            fontSize: 10,
            color: 'var(--t3, #4d5a72)',
            fontStyle: 'italic',
          }}
        >
          {t(hint)}
        </p>
      )}
    </div>
  );
}

export default SqlEditor;
